import * as React from "react";
import { ProgramClassItem, ProgramResponse } from "../../interfaces/program";
import ProgramClass from "./programclass";

interface ProgramClassMonthProps {
    classes: Array<ProgramClassItem>;
    program: ProgramResponse;
}

function formatMonthYear(dateMs: number, timeZone: string) {
    const date = new Date(dateMs);

    const formatter = new Intl.DateTimeFormat("en-US", {
        month: "long",
        year: "numeric",
        timeZone,
    });

    return formatter.format(date);
}

const ProgramClassMonth = ({ classes, program }: ProgramClassMonthProps) => {
    const classlist = classes.map((c) => (
        <ProgramClass
            program={program}
            programclass={c}
            key={c.programClassId}
        />
    ));
    const firstClass = classes[0];

    return (
        <div className="card card-month">
            <h5 className="card-header">
                {formatMonthYear(
                    firstClass.firstScheduleDateMs,
                    firstClass.timezone,
                )}
            </h5>
            <div className="card-body">
                <div className="register-classlist">
                    {classlist}
                </div>
            </div>
        </div>
    );
};

export default ProgramClassMonth;
